/**
 * Formats provider name with appropriate title handling
 * Prevents duplicate "Dr." titles
 */
export const formatProviderName = (provider: {
  title?: string;
  firstName: string;
  lastName: string;
}): string => {
  const { title, firstName, lastName } = provider;
  
  // Check if title already exists and contains "Dr."
  if (title && title.toLowerCase().includes('dr')) {
    return `${title} ${firstName} ${lastName}`;
  }
  
  // Check if firstName already starts with "Dr."
  if (firstName && firstName.toLowerCase().startsWith('dr.')) {
    return `${firstName} ${lastName}`;
  }
  
  // Default to adding "Dr." prefix
  return `Dr. ${firstName} ${lastName}`;
};

/**
 * Gets display name for provider without adding titles
 * Use this when you just want the name without automatic title prefixing
 */
export const getProviderDisplayName = (provider: {
  title?: string;
  firstName: string;
  lastName: string;
}): string => {
  const { title, firstName, lastName } = provider;
  
  if (title) {
    return `${title} ${firstName} ${lastName}`;
  }
  
  return `${firstName} ${lastName}`;
};